import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import {
  selectAllIdInTable,
  selectCheckboxFollow,
  selectIdsTableFollowingList,
} from '../store/slice'

export const CustomThTitleFollowingList = ({ item }) => {
  const dispatch = useDispatch()

  const idsTable = useSelector(selectIdsTableFollowingList)
  const checkboxObj = useSelector(selectCheckboxFollow(['listIdsSelected']))

  const isCheck = idsTable.some((item) => checkboxObj[item])
  const isOutCheck = idsTable.every((item) => checkboxObj[item])

  const handleClick = (value) => {
    dispatch(selectAllIdInTable(value))
  }

  return (
    <Element className="dFlex">
      <Checkbox
        styleIcon={{ fontSize: 13, paddingRight: 16 }}
        checked={
          !idsTable.length
            ? false
            : isOutCheck
            ? isOutCheck
            : isCheck
            ? -1
            : false
        }
        onChange={handleClick}
        isCheckOnClickText
        title={
          <Element>
            <Translate value={item} />
          </Element>
        }
      />
    </Element>
  )
}
